/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Version } from './version';


export interface AdminFirmwareVersionDto { 
    id?: string;
    version?: Version;
    addedDeviceFeatures?: Array<AdminFirmwareVersionDto.AddedDeviceFeaturesEnum>;
    removedDeviceFeatures?: Array<AdminFirmwareVersionDto.RemovedDeviceFeaturesEnum>;
    otherChanges?: string;
    creationDate?: string;
    releaseDescription?: string;
    officialChangelog?: string;
    firmwareClassId?: string;
    binarySize?: number;
    binaryUploadDate?: string;
    binaryChecksum?: string;
    releaseForCustomer?: boolean;
    releaseDate?: string;
    numberOfDevices?: number;
}
export namespace AdminFirmwareVersionDto {
    export const AddedDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type AddedDeviceFeaturesEnum = typeof AddedDeviceFeaturesEnum[keyof typeof AddedDeviceFeaturesEnum];
    export const RemovedDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type RemovedDeviceFeaturesEnum = typeof RemovedDeviceFeaturesEnum[keyof typeof RemovedDeviceFeaturesEnum];
}


export type AddedDeviceFeaturesEnum = typeof AdminFirmwareVersionDto.AddedDeviceFeaturesEnum[keyof typeof AdminFirmwareVersionDto.AddedDeviceFeaturesEnum];
export type RemovedDeviceFeaturesEnum = typeof AdminFirmwareVersionDto.RemovedDeviceFeaturesEnum[keyof typeof AdminFirmwareVersionDto.RemovedDeviceFeaturesEnum];
